import { satisfies } from 'compare-versions';

import { parseAgentVersion } from './parseAgentVersion';

export const REQUIRED_AGENT_VERSION_FOR_EVICTOR = '0.49.1';

export const isAgentVersionSufficientForEvictor = (
  agentVersion: string
): boolean => {
  return satisfies(
    parseAgentVersion(agentVersion),
    `>=${REQUIRED_AGENT_VERSION_FOR_EVICTOR}`
  );
};
